import {createPreloadableLazyComponent} from '../../util/lazyImport';
import {type RouteData} from '../types';
import {
  FORGE_NOTEBOOK_PATH,
  MARIMO_NOTEBOOK_EDIT_PATH,
  NOTEBOOKS_HOME_PATHS,
} from './notebookPaths';

export const NOTEBOOKS_HOME_ROUTES_DATA: RouteData[] = [
  {
    additionalProps: {
      allowIframes: false,
      skipTracking: true, // HomePageWithData handles tracking via HOME_NESTED_ROUTES
    },
    exact: true,
    isPrivateRoute: true,
    path: NOTEBOOKS_HOME_PATHS,
    RouteComponent: createPreloadableLazyComponent(
      () => import('../../pages/HomePage/HomePageWithData')
    ).Component,
  },
];

export const NOTEBOOK_ROUTES_DATA: RouteData[] = [
  {
    additionalProps: {
      allowIframes: false,
      skipTracking: true,
    },
    exact: true,
    isPrivateRoute: true,
    path: MARIMO_NOTEBOOK_EDIT_PATH,
    RouteComponent: createPreloadableLazyComponent(
      () => import('../../pages/ProjectPage')
    ).Component,
  },
];

export const FORGE_NOTEBOOK_ROUTES_DATA: RouteData[] = [
  {
    additionalProps: {
      allowIframes: false,
      datadogViewName: 'Notebooks',
    },
    exact: true,
    isPrivateRoute: true,
    path: FORGE_NOTEBOOK_PATH,
    RouteComponent: createPreloadableLazyComponent(
      () => import('../../pages/MarimoNotebookRuntimePage')
    ).Component,
  },
];
